import * as React from 'react';
import {useState} from 'react';
import ButtonComponent, { ButtonVariant } from '../ButtonComponent';
import { Sheet , SheetContent, SheetHeader, SheetTitle} from '../../ui/sheet';

type Props = {
    contentClassName?: string
    buttonClassName?: string,
    buttonLabel: string | React.ReactNode
    title?: string | React.ReactNode
    buttonVariant?: ButtonVariant
    buttonIcon?: React.ReactNode
    titleClassName?: string
    children?:  React.ReactNode | ((isOpen: boolean, setIsOpen: (state: boolean) => void) => React.ReactNode)
};
const SheetComponent = ({
                            contentClassName = "", buttonVariant, titleClassName = "",
                            buttonClassName = "", buttonLabel, children, title = "", buttonIcon
                        }: Props) => {

    const [isOpen, setIsOpen] = useState(false)

    return (
        <Sheet open={isOpen} onOpenChange={open => setIsOpen(open)}>
            <ButtonComponent icon={buttonIcon} variant={buttonVariant} label={buttonLabel} onClick={(event) => {
                event.stopPropagation()
                setIsOpen(true)
            }} className={buttonClassName} />
            <SheetContent className={contentClassName}>
                <SheetHeader>
                    <SheetTitle className={titleClassName}>{
                        title
                    }</SheetTitle>
                </SheetHeader>
                {children ? typeof children === "function" ? children(isOpen, setIsOpen) : children : null}
            </SheetContent>
        </Sheet>
    );
};

export default SheetComponent